<template>
  <div id="charg">
    <div class="charg_p">
      <!-- <div >抓药列表</div> -->
      <div class="right">
        <el-date-picker
          :class="{dateclass:active}"
          v-model="chartTimeValue"
          type="daterange"
          :clearable="false"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="charg_date"
          style="overflow: hidden;margin-bottom: -15px;line-height: 10px;"
        ></el-date-picker>

        <el-input :class="{inputclass:active}" v-model="input" placeholder="请输入姓名或手机号"></el-input>
        <el-button type="primary" class="el-icon-search" @click="searchButton"></el-button>
      </div>
    </div>
    <template>
      <el-table
        border
        :data="medicineList"
        style="width: 100%"
        @row-click="openDetails"
        :header-cell-style="tableHeaderColor"
      >
      <el-table-column prop="emergencyCode" label="紧急程度" width="80px;">
          <template slot-scope="scope">
            <el-button round size="mini" :icon="scope.row.emergencyCode == 0 ? 'el-icon-warning' : (scope.row.emergencyCode == 1 ? 'el-icon-success' : 'el-icon-star-on')" :type="scope.row.emergencyCode == 0 ? '' : (scope.row.emergencyCode == 1 ? 'success' : 'danger')"></el-button>
          </template>
        </el-table-column>
        <el-table-column prop="orderNumber" label="订单号" width="auto"></el-table-column>
        
        <el-table-column prop="patientBaseEntity.name" label="姓名" width="auto"></el-table-column>
        <el-table-column prop="patientBaseEntity.gender" label="性别" width="auto"></el-table-column>
        <el-table-column prop="patientBaseEntity.mobileNumber" label="手机号"></el-table-column>
        <el-table-column prop="patientBaseEntity.age" label="周岁" width="auto"></el-table-column>
        <el-table-column prop="doctorName" label="开单医生"></el-table-column>
        <el-table-column prop="orderDate" label="日期"></el-table-column>

        <el-table-column prop="orderStatus" label="状态">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.orderStatus === 1 ? 'danger' :(scope.row.orderStatus==4 ? 'danger': 'success')"
              disable-transitions
            >
              {{scope.row.orderStatus==1 ? '待抓药':(scope.row.orderStatus==2 ? '已抓药':
              (scope.row.orderStatus==4 ? '待邮寄':'已邮寄'))}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="getMedicineDateTime" label="抓药时间"></el-table-column>
        <el-table-column label="操作" width="180">
          <template scope="scope">
            <el-button
              type="text"
              size="small"
              @click="checkClick(scope.row)"
              v-if="scope.row.orderStatus!=1"
            >查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="block">
      <el-pagination
        small
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync=Current
        :page-size="this.Size"
        layout="total,prev, pager, next, jumper"
        :total="this.total"
      ></el-pagination>
    </div>
  </div>
</template>
<style scoped>
  .el-button--primary {
    color: #fff;
    background-color:  rgb(60, 110, 169);
    border-color: rgb(60, 110, 169);
  }
  .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #fff;
    background-color: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
  }
  .el-button--primary:focus, .el-button--primary:hover {
    background: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
    color: #fff;
  }
#charg {
  width: 98%;
  margin-left: 15px;
  padding-bottom: 50px;
  background-color: white;
  /*margin: 30px 20px;*/
}

.block {
  margin-top: 20px;
  padding-left: 33%;
}

.charg_p {
  border-bottom: 1px solid #e7e7e7;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.68);
  line-height: 70px;
  padding: 0 20px 0 10px;
}

.charg_p div {
  display: inline-block;
}

.right {
  float: right;
}

.inputclass {
  width: 200px !important;
}
</style>
<script>
import { formatDate } from "../../common/date";

export default {
  data() {
    return {
      timeOut: null,
      dataList: {},
      total: 0,
      Size: 10,
      Current: 1,
      currentPage: 0,
      active: true,
      medicineList: [],
      input: "",
      tags: ["tag", "待抓药"],
      charg_date: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      chartTimeValue: [Date.now(), Date.now()]
    };
  },
  mounted: function() {
    let session = JSON.parse(sessionStorage.getItem("timeData"));
    this.dataList = {     // 当天数据
      startDate: formatDate(this.chartTimeValue[0], "yyyy-MM-dd"),
      endDate: formatDate(this.chartTimeValue[1], "yyyy-MM-dd")
    };
    if(session != null){
       this.chartTimeValue = [];
       this.chartTimeValue.push(session.startDate);
       this.chartTimeValue.push(session.endDate);
       this.dataList = {      // 所记录数据
        startDate: formatDate(this.chartTimeValue[0], "yyyy-MM-dd"),
        endDate: formatDate(this.chartTimeValue[1], "yyyy-MM-dd")
       }
       this.getinfo(); 
    }else{
      this.getinfo();
    }
  },
  destroyed() {
    clearTimeout(this.timeOut);
  },
  methods: {
    getinfo: function() {
      this.$axios({
        url:
          "/api/order/" +
          1 +
          "/pageNumber/" +
          this.Current +
          "/size/" +
          this.Size,
        method: "POST",
        data: this.dataList,
        showLoading: false
      })
        .then(res => {
          this.medicineList = res.data.data.content;
          this.total = res.data.data.totalElements;

          this.timeOut = setTimeout(() => {
          this.getinfo();
          }, 60000);
        })
        .catch(err => {
          clearTimeout(this.timeOut);
        });
    },
    searchButton: function() {
      this.Current=1;
        if (this.input !== "") {
        let frist = this.input.split("")[0];
        if (frist == 1) {
          this.dataList.mobileNumber = this.input;
          this.dataList.startDate = formatDate(
            this.chartTimeValue[0],
            "yyyy-MM-dd"
          );
          this.dataList.endDate = formatDate(
            this.chartTimeValue[1],
            "yyyy-MM-dd"
          );
          this.getinfo();
        } else {
          this.dataList.patientName = this.input;
          this.dataList.startDate = formatDate(
            this.chartTimeValue[0],
            "yyyy-MM-dd"
          );
          this.dataList.endDate = formatDate(
            this.chartTimeValue[1],
            "yyyy-MM-dd"
          );
          this.getinfo();
        }
      } else {
          this.dataList={};
        this.dataList.startDate = formatDate(
          this.chartTimeValue[0],
          "yyyy-MM-dd"
        );
        this.dataList.endDate = formatDate(
          this.chartTimeValue[1],
          "yyyy-MM-dd"
        );
        let jsonStr = JSON.stringify(this.dataList);
        sessionStorage.setItem("timeData", jsonStr);
          this.getinfo();
      }
    },
    handleSizeChange(val) {
      this.Size = val;
    },
    handleCurrentChange(val) {
      this.Current = val;
      this.getinfo();
    },
    filterTag(value, row) {
      return row.orderStatus === value;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    //  1为待抓药 4 待邮寄
    openDetails(row) {
      if (row.orderStatus == 1 || row.orderStatus == 4) {
        let data = {
          orderNumber: row.orderNumber,
          status: row.orderStatus
        };
        data = JSON.stringify(data);
        this.$router.push({ path: "./medicineDetail", query: { data: data } });
      }
    },
    //   2为已抓药 5为已邮寄
    checkClick: function(val) {
      if (val.orderStatus == 2 || val.orderStatus == 5) {
        let Data = {
          orderNumber: val.orderNumber,
          status: val.orderStatus
        };
        Data = JSON.stringify(Data);
        this.$router.push({ path: "./medicineDetail", query: { Data: Data } });
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#f2f2f2;color: #a4a7af;";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// medicine_list.vue?d3be4320